import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { decodeQueryString } from '../queryStringUtils';
import { ALL_POI_TYPE_IDS } from '../poiStaticRepository';
import { validateSearchTypes } from '../helpers/validateSearchTypes';

const useStateFromQueryString = (setState) => {
  const location = useLocation();
  useEffect(() => {
    const queryObject = decodeQueryString(location.search);
    // Check for undefined since key-only query parameters are valid.
    // eslint-disable-next-line no-nested-ternary
    const filter = typeof queryObject.filter !== 'undefined'
      ? queryObject.filter && queryObject.filter.length > 0
        ? queryObject.filter.split(',').filter((it) => it).map(Number)
        : []
      : ALL_POI_TYPE_IDS;
    const speciesFilter = queryObject.speciesFilter
      ? Number(queryObject.speciesFilter) : -1;
    const zoom = queryObject.zoom
      ? [Number(queryObject.zoom)] : [4.1];
    const searchType = validateSearchTypes(queryObject.searchType) ? queryObject.searchType : '';
    const searchString = queryObject.searchString || '';
    setState({
      filter, speciesFilter, zoom, searchType, searchString,
    });
  }, [location.search]);
};

export default useStateFromQueryString;
